/* eslint-disable camelcase */
type Program = {
  degree_abbrev: string;
  program_abbrev: string;
  id: string;
  description: string;
  first_semester: string;
  program_name: string;
  short_name: string;
  university_code: string;
  versions: any;
  label: string;
  value: string;
};

// export const DummyUser: User = {
//   name: 'Visarut',
//   lastname: 'Techatanachai
//   picture: 'https://picsum.photos/200',
// };

export const EmptyPrograms: Array<Program> = [];
export const EmptyProgram: Program = {
  degree_abbrev: "",
  program_abbrev: "",
  id: "",
  description: "",
  first_semester: "",
  program_name: "",
  short_name: "",
  university_code: "",
  label: "",
  value: "",
  versions: [],
};

export default Program;
